<template>
  <div>
    <div class="pull-left text-left col-12">
      <h5>
        {{ this.$t('reports.conversionDetails.reportTitle') }}
      </h5>
    </div>
    <!-- <div class="row">
      <div class="col-3 m-3">
        <div class="search-actions">
          <input
            type="text"
            class="form-control"
            id="input-action"
            :placeholder="$t('reports.conversionDetails.searchAction')"
            v-model="filter"
            @keyup="searchByFilter"
          />
          <button @click="cleanFilter" class="btn btn-outline-primary">
            {{ $t('actionList.searchButton') }}
          </button>
        </div>
      </div>
    </div> -->
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-if="isLargerInterval" class="row mt-4">
      <div class="col-12">
        <div class="text-center">
          <p>
            <font-awesome-icon
              :icon="['fas', 'project-diagram']"
              style="margin-right: 20px; font-size: 35px;"
            />
          </p>
          <h5>
            Por favor, escolha um período menor
          </h5>
          <p>O intervalo máximo permitido é de <strong> 7</strong> dias</p>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="px-3 board-header">
      <div v-show="!isLargerInterval" class="col-12" style="overflow: auto;">
        <div class="row mt-4 col-12">
          <b-table
            id="table-conversion-details"
            striped
            :items="items"
            :fields="fields"
            :per-page="limit"
            :current-page="currentPage"
          >
            <template v-slot:cell(date)="row">
              <p>{{ dateFormat(row.item.date) }}</p>
            </template>
            <template v-slot:cell(records)="row">
              <p>{{ row.item.records }}</p>
            </template>

            <template v-slot:cell(valids)="row">
              <p>{{ row.item.valids }}</p>
            </template>

            <template v-slot:cell(failures)="row">
              <p>{{ row.item.failures }}</p>
            </template>

            <template v-slot:cell(quarentines)="row">
              <p>{{ row.item.quarentines }}</p>
            </template>

            <template v-slot:cell(duplicates)="row">
              <p>{{ row.item.duplicates }}</p>
            </template>

            <template v-slot:cell(bloqueds)="row">
              <p>{{ row.item.bloqueds }}</p>
            </template>

            <template v-slot:cell(answered)="row">
              <p>{{ row.item.answered }}</p>
            </template>

            <template v-slot:cell(conversion)="row">
              <p>
                {{
                  row.item.answered
                    ? ((row.item.answered / row.item.valids) * 100).toFixed()
                    : 0
                }}
              </p>
            </template>

            <template v-slot:cell(details)="row">
              <b-button
                style="background: none; border: none;"
                @click="openDetails(row.item.ids, row.item.date)"
                ><i class="fas fa-search text-primary"></i
              ></b-button>
            </template>
          </b-table>
          <div class="pagination-area-action-list">
            <b-pagination
              v-model="currentPage"
              :total-rows="itemsTotal"
              :per-page="limit"
              aria-controls="table-conversion-details"
            ></b-pagination>
          </div>

          <div class="col-12 mt-2 text-right">
            <a @click="exportToXLS" title="Exportar para XLS">
              <span class="xls">
                <i class="fas fa-file-excel"></i>
              </span>
            </a>
          </div>

          <b-modal
            ref="modal-details"
            hide-footer
            scrollable
            title="Detalhes"
            size="xl"
          >
            <div class="col-12" style="overflow: auto; height: 100%;">
              <div class="row mt-4 col-12">
                <div v-if="loadingDetails" class="loader">
                  <b-spinner
                    variant="primary"
                    type="grow"
                    :label="`${this.$t('reports.loadingLabel')}...`"
                  ></b-spinner>
                </div>
                <b-table
                  v-else
                  id="table-details"
                  striped
                  :items="itemsDetails"
                  :fields="fieldsDetails"
                >
                </b-table>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';
import Paginate from 'vuejs-paginate';
import XLSX from 'xlsx';
import { format, lightFormat } from 'date-fns';
import pt from 'date-fns/locale/pt';
import * as moment from 'moment';

export default {
  name: 'ConversionDetails',
  components: {
    loader,
    Paginate,
  },

  data: () => ({
    loading: false,
    loadingDetails: false,
    userAuth: null,
    fields: [],
    fieldsDetails: [],
    items: [],
    allItems: [],
    itemsDetails: [],
    itemsTotal: 0,
    categoriesAnalysis: false,
    optionsProfiles: [],
    optionsCategories: [],
    page: 1,
    filter: null,
    limit: 10,
    sortBy: null,
    sortDesc: null,
    currentPage: 1,
    isLargerInterval: false,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.setData();
    },

    myActionId: function watchmyActionId() {
      this.setData();
    },

    myActionsIds: function watchmyActionsIds() {
      this.setData();
    },

    calendarDates: function watchCalendarDates() {
      this.setData()
    },

    myIh1: function watchMyIh1() {
      this.setData();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.setData();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.setData();
    },

    myIh2: function watchMyIh2() {
      this.setData();
    },

    myMetric: function watchMyMetric() {
      this.setData();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.setData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.setData();
    },
  },

  methods: {
    async setData() {
      // restingir intervalo de datas em 7 dias no máximo;
      let start = moment(this.calendarDates.start);
      let end = moment(this.calendarDates.end);

      let verify = end.diff(start, 'days');

      if(verify <= 7){
        this.isLargerInterval = false
        this.getDetails();
      }else{
        this.loading = false;
        this.isLargerInterval = true
      }
    },
    async getDetails(){
      this.loading = true;

      this.items = [];

        this.fields = [
          {
            key: 'date',
            label: 'Data',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'records',
            label: 'Recebidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'valids',
            label: 'Válidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'failures',
            label: 'Inválidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'quarentines',
            label: 'Quarentena',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'duplicates',
            label: 'Duplicados',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'bloqueds',
            label: 'Bloqueados',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'answered',
            label: 'Respondidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'conversion',
            label: '%Conversão',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'details',
            label: 'Detalhes'
          }
        ];

          const response = await api.get('/reports/conversion-details', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
              startDate: this.calendarDates.start ? this.calendarDates.start : null,
              endDate: this.calendarDates.end ? this.calendarDates.end : null,
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myIh2 === '0' ? null : this.myIh2,
              metric: this.myMetric ? this.myMetric : null,
              groupId: this.actionGroupData._id,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,

              page: this.page,
              limit: this.limit,
              filter: this.filter,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc,
            },
          });
          const actions = response.data.details
          this.itemsTotal = response.data.total

          this.allItems = [];

          this.items = actions;

      this.loading = false;
    },
    async getActions(ids, date){
      this.loadingDetails = true;
        this.fieldsDetails = [
          {
            key: 'date',
            label: 'Data',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'controlId',
            label: 'ID Ação',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'name',
            label: 'Ação',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'submits',
            label: 'Importações',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'valids',
            label: 'Válidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'failures',
            label: 'Inválidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'quarentines',
            label: 'Quarentena',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'bloqueds',
            label: 'Bloqueados',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'answered',
            label: 'Respondidos',
            sortable: true,
            class: 'categoryTh',
          },
          {
            key: 'conversion',
            label: '%Conversão',
            sortable: true,
            class: 'categoryTh',
          },
        ];

         const response = await api.get('/reports/conversion-details-actions', {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              date: date,
              actionIds: ids,
            },
          });
          const actions = response.data;
          this.itemsDetails = actions;
          this.loadingDetails = false
    },
    handleSorting(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setData();
    },
    dateFormat(param) {
      const date = moment(param).format('DD/MM/YYYY');
      return date
    },
    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.setData, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.setData();
      }
    },
    cleanFilter() {
      this.filter = null;
      this.setData();
    },
    openDetails(data, date) {
      const ids = [...new Set(data)];
      this.getActions(ids, date.split('T')[0])
      this.$refs['modal-details'].show()
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    exportToXLS() {
      const header = [];
      for (let i = 0; i < this.fields.length; i += 1) {
       if(this.fields[i].label !== 'Detalhes'){
        header.push(this.fields[i].label)
       }
      }

      const arr = []

      this.items.forEach((el)=>{
        arr.push({
        'Data': this.dateFormat(el.date),
        'Recebidos': el.records,
        'Válidos': el.valids,
        'Inválidos': el.failures,
        'Quarentena': el.quarentines,
        'Duplicados': el.duplicates,
        'Bloqueados': el.bloqueds,
        'Respondidos': el.answered,
        '%Conversão': el.answered ? ((el.answered / el.valids) * 100).toFixed() : '0',
        })
      })


      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('categorias');
      const ws = XLSX.utils.json_to_sheet(arr, { header });

      // eslint-disable-next-line
      wb.Sheets['categorias'] = ws;
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'conversao.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loading = true;
    await this.setData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-action-list >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.search-actions {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>
<style lang="scss">
.categoryTh {
  min-width: 50px !important;
}
.valueTh {
  min-width: 50px !important;
}

.pagination-area-action-list .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-action-list a {
  outline: none;
}

.modal.fade .modal-dialog {
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/molecules/highcharts/conversion-details/index.vue